import { motionTokens } from '@/lib/motion'

/**
 * Yüklü satır sayısı bunun altındaysa satır animasyonu (sıralama kayması, kademeli giriş) var,
 * eşit/üstünde anlık (docs/DATA-GRID-PLAN.md Faz 6). Eşik tek yerde; ölçüm notu planın Faz 6'sında.
 */
export const ROW_ANIMATION_MAX_ROWS = 100

/** Kademeli girişin toplam süresi (sn): `motionTokens.stagger` notu, yaklaşık 0,4 sn'yi geçmesin. */
const ENTER_STAGGER_BUDGET = 0.4

/** Satır animasyonu açık mı: yüklü satır eşiğin altında ve kullanıcı hareketi azaltmamış. */
export const shouldAnimateRows = (loadedRows: number, reducedMotion: boolean): boolean =>
  !reducedMotion && loadedRows > 0 && loadedRows < ROW_ANIMATION_MAX_ROWS

/** `index`. satırın giriş gecikmesi (sn): adım `stagger.item`, ama toplam kademe bütçeyi aşmaz. */
export function rowEnterDelay(index: number, count: number): number {
  const step = Math.min(motionTokens.stagger.item, ENTER_STAGGER_BUDGET / Math.max(count, 1))
  return Math.max(index, 0) * step
}
